import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SchedulePush from  '@/components/page/schedulePush/SchedulePush';

class SchedulePushPortal extends Component {
  render() {

    let isArchived: boolean = false
    // Container ref
    const targetContainer = document.getElementById('react-schedulepush-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    else {
      isArchived = targetContainer.getAttribute('data-isarchived') === 'True'
    }

    return ReactDOM.createPortal(
      <SchedulePush contentIsArchived={isArchived}/>
      , targetContainer
    );
  }
}

export default SchedulePushPortal;